"use client";

import { use } from "react";
import SignIn from "./_signin";

export default function Page(props: PageProps<"/login">) {
  const { signup } = use(props.searchParams);

  return (
    <div className="mx-auto w-full max-w-3xl py-6">
      <div className="md:flex w-full overflow-hidden md:rounded-lg bg-white shadow">
        <div className="flex md:h-128 md:max-w-xs shrink-0 flex-col justify-between bg-zinc-900 px-4 md:px-8 py-6 md:py-12">
          <div>
            {signup ? (
              <>
                <div className="mb-6 text-3xl font-bold text-white">
                  Looks like you&apos;re new here!
                </div>
                <div className="font-medium text-zinc-100">
                  Sign up with your mobile number to get started
                </div>
              </>
            ) : (
              <>
                <div className="mb-6 text-3xl font-bold text-white">Login</div>
                <div className="font-medium text-zinc-100">
                  Get access to your Orders, Wishlist and Recommendations
                </div>
              </>
            )}
          </div>
        </div>
        <div className="w-full px-4 md:px-8 py-6 md:py-12">
          <SignIn />
        </div>
      </div>
    </div>
  );
}
